export interface ReqSearchApplicants {
  asc?: boolean
  keyword?: string
  pageNumber: number
  pageSize: number
  sort?: ApplicantsSortKey
  tagCondition?: FilterCondition
  tags?: string[]
}
export interface ResSearchApplicants {
  applicants: ResApplicant[]
  currentPage: number
  pageSize: number
  totalCount: number
  totalPages: number
}

export interface ApplicantsSort {
  key: ApplicantsSortKey
  order: ApplicantsSortOrder
}

export interface ResApplicant {
  applicant_id: number
  applicant_name: string
  email: string
  isUpdated: boolean
  is_public: boolean
  memo: string
  notification_mail: boolean
  notification_sms: boolean
  path_id: number
  phone: string | null
  tags: string[] | null
}

export type ApplicantsSortKey = 'id' | 'name' | 'email'
export type ApplicantsSortOrder = 'asc' | 'desc'
export type FilterCondition = 'and' | 'or'
export const FilterCondition = {
  and: 'and',
  or: 'or',
} as const
